<template>
  <section class="section" id="settlements-panel">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <settlements-title
        @update-date="updateDate"
        @get-settlements="getSettlements"
        @download-settlement-report="downloadSettlementReport"
        @update-store-id="updateStoreId"
      />

      <h2
        v-if="settlements.length === 0 && settlementValues.length === 0"
        class="subtitle has-text-centered"
      >
        {{ $t("settlements.noSettlementsAtThisDate") }}
      </h2>

      <div v-else class="columns has-text-centered is-mobile is-multiline">
        <settlement-card
          :text="$t('settlements.prepaidText')"
          :value="prepaid"
          :description="$t('settlements.prepaidDescription')"
        />

        <settlement-card
          :text="$t('settlements.pixText')"
          :value="pix"
          :description="$t('settlements.pixDescription')"
        />

        <settlement-card
          :text="$t('settlements.debitText')"
          :value="debit"
          :description="$t('settlements.debitDescription')"
        />

        <settlement-card
          :text="$t('settlements.creditText')"
          :value="credit"
          :description="$t('settlements.creditDescription')"
        />

        <settlement-card
          :text="$t('settlements.totalText')"
          :value="total"
          :description="$t('settlements.totalDescription')"
        />

        <!-- <settlement-card
          v-if="tefDebit > 0"
          :text="$t('settlements.tefDebitText')"
          :value="tefDebit"
          :description="$t('settlements.tefDebitDescription')"
        />

        <settlement-card
          v-if="tefCredit > 0"
          :text="$t('settlements.tefCreditText')"
          :value="tefCredit"
          :description="$t('settlements.tefCreditDescription')"
        /> -->

        <settlement-card
          :text="$t('settlements.moneyText')"
          :value="money"
          :description="$t('settlements.moneyDescription')"
        />

        <settlement-card
          :text="$t('settlements.voucherText')"
          :value="voucher"
          :description="$t('settlements.voucherDescription')"
        />

        <!-- Total * taxa (ou 0,1) + Voucher * 0,06 -->
        <settlement-card
          :text="$t('settlements.royaltyText')"
          :value="royalty"
          :description="$t('settlements.royaltyDescription')"
        />

        <settlement-card
          :text="$t('settlements.receivableText')"
          :value="valueToReceive"
          :description="$t('settlements.receivableDescription')"
        />
      </div>
    </div>

    <div v-if="settlement && settlement.details" class="has-text-centered">
      <br />
      <p>
        <b>{{ $t("settlements.status") }}:</b>
        {{
          settlement.details.status === "success"
            ? `${$t("settlements.done")}`
            : `${$t("settlements.pending")}`
        }}
      </p>
      <p>
        <b>{{ $t("settlements.note") }}:</b>
        {{ settlement.details.note ? settlement.details.note : "-" }}
      </p>
    </div>

    <settlements-rules />
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import settlementsTitle from "./SettlementsTitle";
import settlementCard from "./SettlementCard";
import settlementsRules from "./SettlementsRules";

export default {
  mixins: [common],

  components: {
    settlementsTitle,
    settlementCard,
    settlementsRules
  },

  data() {
    return {
      isLoading: false,
      date: new Date(),
      settlement: null,
      storeId: "",

      settlementValuesSum: {
        prepaid: 0,
        pix: 0,
        money: 0,
        debit: 0,
        credit: 0,
        voucher: 0,
        royalty: 0
      }
    };
  },

  computed: {
    ...mapGetters(["settlements", "settlementValues"]),

    prepaid() {
      // TO DO atualizar para settlementValues e deletar?
      const prepaid = this.settlements.length
        ? this.settlements.reduce((t, s) => {
            return s.details.prepaidSettlementDate &&
              s.details.prepaidSettlementDate.substring(0, 10) === this.date
              ? (t += s.details.prepaid)
              : t;
          }, 0)
        : 0;

      // TO DO testar e remover o if
      return prepaid + this.settlementValuesSum.prepaid;
    },

    pix() {
      const pix = this.settlements.length
        ? this.settlements
            .filter(s => {
              return (
                s.details.fundingSource === "pix" &&
                s.details.paymentMethodSettlementDate &&
                s.details.paymentMethodSettlementDate.substring(0, 10) ===
                  this.date &&
                ["adyen", "pagbank"].includes(s.details.provider)
              );
            })
            .reduce((t, s) => {
              return (t += s.details.paymentMethodValue);
            }, 0)
        : 0;

      // TO DO testar e remover o if
      return pix + this.settlementValuesSum.pix;
    },

    money() {
      const money = this.settlements.length
        ? this.settlements
            .filter(s => {
              return s.details.fundingSource === "money";
            })
            .reduce((t, s) => {
              return (t += s.details.paymentMethodValue);
            }, 0)
        : 0;

      // TO DO testar e remover o if
      return money + this.settlementValuesSum.money;
    },

    debit() {
      const debit = this.settlements.length
        ? this.settlements
            .filter(s => {
              return (
                s.details.fundingSource === "debit" &&
                s.details.paymentMethodSettlementDate &&
                s.details.paymentMethodSettlementDate.substring(0, 10) ===
                  this.date &&
                s.details.provider === "adyen"
              );
            })
            .reduce((t, s) => {
              return (t += s.details.paymentMethodValue);
            }, 0)
        : 0;

      // TO DO testar e remover o if
      return debit + this.settlementValuesSum.debit;
    },

    credit() {
      const credit = this.settlements.length
        ? this.settlements
            .filter(s => {
              return (
                s.details.fundingSource === "credit" &&
                s.details.paymentMethodSettlementDate &&
                s.details.paymentMethodSettlementDate.substring(0, 10) ===
                  this.date &&
                s.details.provider === "adyen"
              );
            })
            .reduce((t, s) => {
              return (t += s.details.paymentMethodValue);
            }, 0)
        : 0;

      // TO DO testar e remover o if
      return credit + this.settlementValuesSum.credit;
    },

    total() {
      return this.prepaid + this.pix + this.debit + this.credit;
    },

    // tefDebit() {
    //   const debit = this.settlements.length
    //     ? this.settlements
    //         .filter(s => {
    //           return (
    //             s.details.fundingSource === "debit" &&
    //             s.details.paymentMethodSettlementDate &&
    //             s.details.paymentMethodSettlementDate.substring(0, 10) ===
    //               this.date &&
    //             s.details.format === "tef"
    //           );
    //         })
    //         .reduce((t, s) => {
    //           return (t += s.details.paymentMethodValue);
    //         }, 0)
    //     : 0;

    // TO DO testar e remover o if
    //  return debit;
    //},

    // tefCredit() {
    //   const credit = this.settlements.length
    //     ? this.settlements
    //         .filter(s => {
    //           return (
    //             s.details.fundingSource === "credit" &&
    //             s.details.paymentMethodSettlementDate &&
    //             s.details.paymentMethodSettlementDate.substring(0, 10) ===
    //               this.date &&
    //             s.details.format === "tef"
    //           );
    //         })
    //         .reduce((t, s) => {
    //           return (t += s.details.paymentMethodValue);
    //         }, 0)
    //     : 0;

    //   // TO DO testar e remover o if
    //   return credit;
    // },

    voucher() {
      const voucher = this.settlements.length
        ? this.settlements
            .filter(s => {
              return (
                s.details.fundingSource === "voucher" &&
                s.details.paymentMethodSettlementDate &&
                s.details.paymentMethodSettlementDate.substring(0, 10) ===
                  this.date &&
                s.details.provider === "adyen"
              );
            })
            .reduce((t, s) => {
              return (t += s.details.paymentMethodValue);
            }, 0)
        : 0;

      // TO DO testar e remover o if
      return voucher + this.settlementValuesSum.voucher;
    },

    royalty() {
      // TO DO (?) Alterar para soma dos valores de royalty quando não estiver toFixed(0) na transação?
      const royalty = this.settlements.length
        ? this.settlements.reduce((t, s) => {
            let hasPrepaidSettlement =
              s.details.prepaidSettlementDate &&
              s.details.prepaidSettlementDate.substring(0, 10) === this.date;

            let hasPaymentMethodSettlement =
              s.details.paymentMethodSettlementDate &&
              s.details.paymentMethodSettlementDate.substring(0, 10) ===
                this.date;

            let prepaidRoyalty = 0;

            if (hasPrepaidSettlement) {
              prepaidRoyalty = !isNaN(s.details.royaltyPercentage)
                ? s.details.prepaid * s.details.royaltyPercentage
                : s.details.prepaid * 0.1;
            }

            let paymentMethodRoyalty = 0;

            if (hasPaymentMethodSettlement) {
              paymentMethodRoyalty = !isNaN(s.details.royaltyPercentage)
                ? s.details.paymentMethodValue * s.details.royaltyPercentage
                : s.details.paymentMethodValue * 0.1;
            }

            return (t += prepaidRoyalty + paymentMethodRoyalty);
          }, 0)
        : 0;

      // TO DO testar e remover o if
      return royalty + this.settlementValuesSum.royalty;
    },

    valueToReceive() {
      return this.total - this.royalty;
    }
  },

  methods: {
    getSettlements() {
      this.isLoading = true;
      this.clearSettlementInfo();

      this.$store
        .dispatch("getSettlements", {
          date: this.date.toString(),
          storeId: this.storeId
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.settlement = res.data.payload.settlement;
            this.sumSettlementValues();
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    downloadSettlementReport() {
      this.isLoading = true;
      this.$store
        .dispatch("downloadSettlementReport", this.date)
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    updateDate(date) {
      date = date || this.date;
      const y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;

      this.date = `${y}-${m}-${d}`;

      this.getSettlements();
    },

    sumSettlementValues() {
      for (let i = 0; i < this.settlementValues.length; i++) {
        if (this.settlementValues[i].v) {
          this.settlementValuesSum[
            this.settlementValues[i].f
          ] += this.settlementValues[i].v;
        }

        if (this.settlementValues[i].r) {
          this.settlementValuesSum.royalty += this.settlementValues[i].r;
        }
      }
    },

    clearSettlementInfo() {
      this.settlementValuesSum = {
        prepaid: 0,
        pix: 0,
        debit: 0,
        credit: 0,
        money: 0,
        voucher: 0,
        royalty: 0
      };
    },

    updateStoreId(storeId) {
      this.storeId = storeId;
      console.log(storeId);
    }
  },

  mounted() {
    this.updateDate();
    this.getSettlements();
  }
};
</script>

<style scoped>
#settlements-panel {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
</style>
